export default class User {
  constructor(firstName, lastName, username, role, orgId, apps, lwt, email) {
    this.firstName = firstName == null ? '' : firstName;
    this.lastName = lastName == null ? '' : lastName;
    this.username = username == null ? '' : username;
    this.role = role == null ? null : role;
    this.products = apps == null ? null : apps;
    this.orgId = orgId == null ? null : orgId;
    this.lwt = lwt;
    this.email = email == null ? '' : email;
    this.isInternal = !email || email.endsWith('@lwolf.com');
  }
}
